import { MvtDistillationVci } from './mvt-distillation-vci.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DREVSaisie {
    static jsonMap = {
        id: 'id',
        codeProduit: 'codeProduit',
        mention: 'mention',
        vciRemplacement: 'vciRemplacement',
        vciSubstitution: 'vciSubstitution',
        vciComplement: 'vciComplement',
        vciNouveau: 'vciNouveau',
        distillations: { key: 'distillations', converter: new (ArrayClassConverterFactory.build(MvtDistillationVci))() }
    };

    public id: number = undefined;
    codeProduit: string = undefined;
    mention: string = undefined;
    vciRemplacement = 0.0;
    vciSubstitution = 0.0;
    vciComplement = 0.0;
    vciNouveau = 0.0;
    distillations: MvtDistillationVci[] = [];

    vciDetruit = 0.0;
    stockVci: number = null;

  get totalVciUtilise() {
    return this.vciComplement + this.vciRemplacement + this.vciSubstitution;
  }

  get totalVciDetruit(): number {
    return (this.distillations || [])
      .reduce((sum, mvt) => sum + (mvt.volume || 0), 0);
  }
}
